// El correo que llega en el link (?email=: recordatorio, carrito abandonado).
// Aterriza en la ficha y se pierde al navegar dentro de la compra: se guarda
// en la pestaña y "Tus datos" lo usa si la sesión todavía no tiene correo.
const LINK_EMAIL_KEY = 'avantti:checkout-link-email';

export const storeLinkEmail = (search: string): void => {
  const email = new URLSearchParams(search).get('email')?.trim();
  if (!email || !email.includes('@')) {
    return;
  }
  try {
    sessionStorage.setItem(LINK_EMAIL_KEY, email);
  } catch {
    // Sin storage: "Tus datos" lo busca igual en la URL.
  }
};

export const readLinkEmail = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const fromUrl = new URLSearchParams(window.location.search).get('email')?.trim();
  if (fromUrl && fromUrl.includes('@')) {
    return fromUrl;
  }
  try {
    return sessionStorage.getItem(LINK_EMAIL_KEY);
  } catch {
    return null;
  }
};
